<template>
  <div class="flexrow align_center space_between mb-8">
    <div>
      <h1 class="page-title mb-0 mr-2 pl-2">{{ title }}</h1>
    </div>
    <div v-if="showCurrentRoundStatus" class="flexrow align_center flex-grow-1">
      <p v-if="showCurrentRoundStatus" class="mb-0 ml-auto mr-2">
        Current Round: {{ currentRoundNumber }}
      </p>
      <NumeraiTooltip
        v-if="showCurrentRoundStatus"
        :text-list="[currentRoundStatusIndicator, currentRoundCloseTime]"
      >
        <div
          class="round-status"
          :class="{
            open:
              currentRoundStatus !== 'Closed' && currentRoundStatus !== 'N/A',
          }"
        ></div>
      </NumeraiTooltip>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getTournamentNumber } from '@/lib/utils'
import moment from 'moment'

export default {
  components: {
    NumeraiTooltip: () => import('@/components/shared/NumeraiTooltip'),
  },
  props: {
    title: { type: String, default: null },
    showCurrentRound: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(['currentRoundInfo']),
    showCurrentRoundStatus() {
      return (
        this.showCurrentRound &&
        this.currentRoundInfo &&
        this.currentRoundInfo.number
      )
    },
    currentRoundNumber() {
      if (!this.currentRoundInfo) {
        return null
      }
      return this.currentRoundInfo.number
    },
    currentRoundStatusIndicator() {
      if (!this.currentRoundInfo) {
        return `Next round opening soon!`
      } else if (this.currentRoundStatus !== 'Closed') {
        return `Round ${this.currentRoundNumber} is open`
      } else {
        return `Round ${this.currentRoundNumber} is closed for submissions`
      }
    },
    currentRoundCloseTime() {
      if (!this.currentRoundInfo) {
        return
      }
      return `Submissions close${
        this.currentRoundStatus === 'Closed' ? 'd' : ''
      } at: ${moment(this.currentRoundInfo.closeStakingTime).format('LT L')}`
    },
    currentRoundStatus() {
      if (!this.currentRoundInfo) {
        return 'N/A'
      }
      if (new Date() > new Date(this.currentRoundInfo.closeStakingTime)) {
        return 'Closed'
      } else {
        return 'Open'
      }
    },
  },
  async created() {
    if (this.showCurrentRound) {
      await this.$store.dispatch('fetchCurrentRoundInfo', getTournamentNumber())
    }
  },
}
</script>

<style scoped>
.round-status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--color-grey30);
}

.round-status.open {
  background: var(--color-happy-green);
  box-shadow: 0 0 0 0 var(--color-happy-green);
  transform: scale(1);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 168, 0, 0.5);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 168, 0, 0);
  }
}
</style>
